import * as actionTypes from "../actionTypes/actionTypes";
import {
    getViewsService,
    createNewViewService,
    deleteViewService,
    saveViewService
} from "../services/ViewsService";

const getViews = (modelId) => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.GET_VIEWS
        })
        window.startLoading();
        getViewsService(modelId)
        .then((response) => {
            const data = response.data;
            dispatch({
                type: actionTypes.GET_VIEWS_SUCCESS,
                payload: data
            })
        })
        .catch((error) => {
            dispatch({
                type: actionTypes.GET_VIEWS_FAILURE,
                payload: error
            })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}

const createNewView = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_VIEW,
    });
    window.startLoading();
    await createNewViewService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_VIEW_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_VIEW_FAILURE,
          payload: error,
        });
      }).finally(()=>{
        window.stopLoading();
      });
  };
};

const UpdateView = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_VIEW,
    });
    await saveViewService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.UPDATE_VIEW_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_VIEW_FAILURE,
          payload: error,
        });
      });
  };
};


const setViewSelectedPage = (requestPayload) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SELECTED_VIEW_PAGE,
      payload: requestPayload
    })
  }
}

const deleteView = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_VIEW,
    });
    window.startLoading();
    await deleteViewService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.DELETE_VIEW_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.DELETE_VIEW_FAILURE,
          payload: error,
        });
      }).finally(()=>{
        window.stopLoading();
      });
  };
};

export { getViews, createNewView, deleteView , UpdateView, setViewSelectedPage};